module.exports = __webpack_public_path__ + "/bundle/asset/plan-1-c66e688655cf0ca0a9fe94e1cf0aa5bf.png";